import moment from 'moment'
import 'moment/locale/ko'

export const getFormatDate = (date, isMobile) => {
  let formatDate = date

  if (formatDate && moment(date).isValid()) {
    formatDate = moment(date).format(
      window.innerWidth <= 480 || isMobile
        ? `YYYY. MM. DD.`
        : 'YYYY년 MM월 DD일(dd)',
    )
  }

  return formatDate
}
